import { render, staticRenderFns } from "./ConfirmOrderChangeRequestDialog.vue?vue&type=template&id=2ecdf10c&scoped=true"
import script from "./ConfirmOrderChangeRequestDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderChangeRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrderChangeRequestDialog.vue?vue&type=style&index=0&id=2ecdf10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdf10c",
  null
  
)

export default component.exports